import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {deleteTableRecord} from "../../../../features/tableSlice";
import {confirmAction} from "../../../util";
import {useState} from "react";
import {setSchemaManagePageArchiveOpen} from "../../../../features/schemaManageSlice";
import {OverlayContainer} from "../../../misc/ImageViewer";
import EditTableRecord from "./EditTableRecord";
import {schemas} from "../../../../config";


type PropsI = { pkValue: string | number, tableKey: string };
export default function RawEditTableRecordModal({pkValue, tableKey}: PropsI) {


    const dispatch = useAppDispatch();

    const [isOpen, setIsOpen] = useState(false);
    const project = useAppSelector(state => state.project.name);
    const schema = schemas[project];


    return <>
        <Button className={'btn-cmn'} onClick={() => setIsOpen(true)}>
            Редагувати
        </Button>
        {isOpen && <OverlayContainer $isVisible onClick={() => setIsOpen(false)}>
            <Container onClick={(e: { stopPropagation: () => void; }) => e.stopPropagation()}>
                <EditTableRecord fields={schema.tables[tableKey].fields} backendUrl={schema.backend} project={project}
                                 closeEdit={() => setIsOpen(false)}
                                 tableKey={tableKey} pkValue={pkValue}/>
            </Container>
        </OverlayContainer>}
    </>
}

const Button = styled.div`
    width: 100%;
`

const Container = styled.div`
    //height: 100%;
    max-height: calc(98vh - var(--header-height));
    height: 100%;
    background-color: var(--table-row-odd-bg-color);
    padding: .5rem;
    border-radius: .5rem;
    max-width: 1200px;
    width: 100%;
    min-width: 340px;
    min-height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
    gap: .5rem;


    .controls {
        display: flex;
        justify-content: end;
        gap: .5rem;
    }

    .check {
        display: flex;
        margin-top: auto;
        gap: .5rem;
    }

    & .entries {
        display: flex;
        flex-flow: column;
        gap: .5rem;
        justify-content: center;
    }

    .loader {
        width: 100%;
        height: 500px;
    }
`
